/**
 * What a number field keeps after a keystroke. A decimal is typed with a comma as often
 * as with a dot («45,3»), and the field stores it with a dot. Returns the text to store,
 * or `null` when the typed text is not a number being typed (the field then keeps its
 * previous value). `maxDecimals` limits the digits after the point; without it they are free.
 * Only the first comma is replaced on purpose: a second separator makes the text «not a number».
 */
export function typedDecimal(typed: string, maxDecimals?: number): string | null {
  const withDot = typed.replace(",", ".");
  const digitsAfterPoint = maxDecimals === undefined ? "\\d*" : `\\d{0,${maxDecimals}}`;
  const numberBeingTyped = new RegExp(`^\\d*(\\.${digitsAfterPoint})?$`);
  return numberBeingTyped.test(withDot) ? withDot : null;
}

/** Puts what was typed into a number field, unless it is not a number. */
export function setTypedDecimal(
  setField: (text: string) => void,
  typed: string,
  maxDecimals?: number
): void {
  const decimal = typedDecimal(typed, maxDecimals);
  if (decimal !== null) setField(decimal);
}
